import { render, staticRenderFns } from "./old-list.vue?vue&type=template&id=2d401994&scoped=true"
import script from "./old-list.vue?vue&type=script&lang=js"
export * from "./old-list.vue?vue&type=script&lang=js"
import style0 from "./old-list.vue?vue&type=style&index=0&id=2d401994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d401994",
  null
  
)

export default component.exports